import React, { useContext, useEffect, useState } from "react";
import { Box, Chip, Grid, Rating, Typography } from "@mui/material";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "../../utils/common/common";
import { FEEDBACK_TYPE_FEEDBACK } from "../../model";
import Comments from "../feedback/comments";
import { getDateTime } from "../../utils/data";
import { capitalize } from "lodash";
import DateTime from "../../utils/common/DateTime";

const BasicDetails = (props: any) => {
  const { detailRow, pageType, selectedPriority } = props;
  const renderPriority = (status: string) => {
    let statusColor = { color: "", background: "", border: "" };

    if (status === "high" || status === "highest") {
      statusColor = {
        border: "1px solid #FA3F3F",
        color: "#FA3F3F",
        background: "#fff",
        // background: "rgb(255 134 82 / 10%)",
      };
    }

    if (status === "medium") {
      statusColor = {
        color: "#FFA500",
        background: "#fff",
        border: "1px solid #FFA500",
      };
    }

    if (status === "low" || status === "lowest") {
      statusColor = {
        color: "#0096FF",
        background: "#fff",
        border: "1px solid #0096FF",
      };
    }

    return (
      <Chip
        label={status}
        size="small"
        sx={{
          fontSize: "11px",
          textTransform: "capitalize",
          ...statusColor,
        }}
      />
    );
  };
  return (
    <Box className="user-reports tickets">
      {detailRow && (
        <Accordion defaultExpanded>
          <AccordionSummary
            aria-controls={"panel1-content"}
            id={"panel1-header"}
          >
            <Typography className="title-sm1 accordianTitle">
              basic details
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ p: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} sx={{ position: "relative" }}>
                <Typography className="title-sm1">Date & Time</Typography>
                <Typography className="info">
                  {detailRow?.createdOn ? (
                    <DateTime date={detailRow.createdOn} />
                  ) : (
                    ""
                  )}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography className="title-sm1">Category</Typography>
                <Typography className="info">
                  {detailRow?.feedbackCategory
                    ? capitalize(detailRow.feedbackCategory)
                    : "-"}
                </Typography>
              </Grid>
              {pageType != "feature" ? (
                <Grid item xs={12} md={4}>
                  <Typography className="title-sm1">
                    {detailRow?.bugPriority == "" &&
                    detailRow?.feedbackType === FEEDBACK_TYPE_FEEDBACK
                      ? "Rating"
                      : "Severity"}
                  </Typography>
                  {detailRow?.bugPriority == "" &&
                  detailRow?.feedbackType === FEEDBACK_TYPE_FEEDBACK ? (
                    <Rating
                      sx={{ margin: "-4px !important" }}
                      className="ratings"
                      name="read-only"
                      value={detailRow?.productRating || 0}
                      readOnly
                    />
                  ) : (
                    <>
                      {/* <Chip
                        label={detailRow?.bugPriority}
                        size="small"
                        color="primary"
                        variant="outlined"
                      /> */}
                      {detailRow?.feedbackType != "FEEDBACK" &&
                      selectedPriority != "" ? (
                        renderPriority(selectedPriority)
                      ) : (
                        <Typography className="info">Unknown</Typography>
                      )}
                    </>
                  )}
                </Grid>
              ) : (
                <></>
              )}
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12} sx={{ position: "relative" }}>
                <Typography className="report-info">
                  {detailRow?.feedbackComments ? (
                    <Comments
                      comments={
                        detailRow.feedbackComments &&
                        Object.keys(detailRow.feedbackComments).length > 0
                          ? detailRow.feedbackComments
                          : undefined
                      }
                      category={detailRow.feedbackCategory}
                      feedbackType={detailRow.feedbackType}
                      feedbackDetails={detailRow}
                    />
                  ) : (
                    ""
                  )}
                </Typography>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      )}
    </Box>
  );
};

export default withSnackbar(BasicDetails);
